<div class="main-container" data-cy="general-confirm">

  <div class="header" data-cy="general-confirm-message">
    {{ message }}
  </div>

  <div class="action-container" data-cy="general-confirm-actions">

    <div *ngFor="let actionButton of actionButtons" [class.inline-button]="inlineButtons" data-cy="general-confirm-action">
      <button *ngIf="actionButton.raised"
              mat-raised-button
              color="{{actionButton.color}}"
              (click)="onActionButtonPressed(actionButton)"
              [attr.data-cy]="'general-confirm-raised-button-' + actionButton.displayText.toLowerCase().replace(' ', '-')">
        {{ actionButton.displayText }}
      </button>
      <button *ngIf="!actionButton.raised"
              mat-button
              color="{{actionButton.color}}"
              (click)="onActionButtonPressed(actionButton)"
              [attr.data-cy]="'general-confirm-button-' + actionButton.displayText.toLowerCase().replace(' ', '-')">
        {{ actionButton.displayText }}
      </button>
    </div>
  </div>
</div>
